//Project Selector change event
const projectSelector = document.getElementById('project-selector');
if (projectSelector) {
    projectSelector.addEventListener('change', function () {
        window.location.href = '/breaking-ground/' + projectSelector.value;
    });
}

//Project Selector change event
const citySelector = document.getElementById('city-selector');
if (citySelector) {
    citySelector.addEventListener('change', function () {
        window.location.href = '/breaking-ground/?filter=city&q=' + citySelector.value;
    });
}

//Project Selector change event
const typeSelector = document.getElementById('type-selector');
if (typeSelector) {
    typeSelector.addEventListener('change', function () {
        window.location.href = '/breaking-ground/?filter=type&q=' + typeSelector.value;
    });
}



// WEBPACK FOOTER //
// ./scripts/util/BreakingGround.js